import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { PaymentTermFormDialog } from "../payment-term-form-dialog";

import { Button } from "@mui/material";

export const EditPaymentTermFormDialog = ({
  paymentTermId,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchPaymentTerm = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, description, dueDays, status },
          },
        } = await apiClient.get(`payment-terms/${paymentTermId}`);
        setDefaultValues({
          name,
          description,
          dueDays,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPaymentTerm();
  }, [paymentTermId]);

  const handleSubmit = async (formData) => {
    try {
      await apiClient.put(`payment-terms/${paymentTermId}`, formData);

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui syarat pembayaran"));

      throw error;
    }
  };

  return (
    <PaymentTermFormDialog
      onClose={onClose}
      dialogTitle="Ubah Syarat Pembayaran"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditPaymentTermFormDialog.propTypes = {
  paymentTermId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
